{
  "version": 1,
  "asset_id": "d0340c13-0d3c-45d4-9348-e2bdf2a6356b",
  "project_id": "93ebf89f-7c73-440e-8d33-7be2cf392b2d",
  "url": "/__l5e/assets-v1/d0340c13-0d3c-45d4-9348-e2bdf2a6356b/rentals-hewescraft-1100.jpg",
  "r2_key": "a/v1/93ebf89f-7c73-440e-8d33-7be2cf392b2d/d0340c13-0d3c-45d4-9348-e2bdf2a6356b/rentals-hewescraft-1100.jpg",
  "original_filename": "rentals-hewescraft-1100.jpg",
  "size": 189587,
  "content_type": "image/jpeg",
  "created_at": "2026-07-03T03:49:16Z"
}
